import Loader from '@space-core/components/loader'
import styled from 'styled-components'

const LoaderWrapper = styled.div`
  height: 100vh;
`

const LoaderFull = () => {
  return (
    <LoaderWrapper className='_h-full _d-flex _align-items-center'>
      <Loader full />
    </LoaderWrapper>
  )
}

export default LoaderFull
